module.exports = __webpack_public_path__ + "static/media/cq_invia_messaggio.b421da6d.svg";